import React, { Children, cloneElement } from 'react';

var Tabs = function (_a) {
    var children = _a.children, activeIndex = _a.activeIndex;
    var getChild = function (child, index) {
        return cloneElement(child, {
            className: "".concat(activeIndex === index ? 'active' : ''),
        });
    };
    var content = Children.map(children, getChild);
    return React.createElement("div", { className: 'view-select-tabs' }, content);
};

export { Tabs };
